/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PersonType from '@linc-technologies/linced-common/enums/person-type';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Field from 'linced-admin/models/people-schema/field';
import type Set from 'linced-admin/models/people-schema/set';

// Proto: people_schema.TemplateGroup.
export default class Group extends Model {
  declare [Type]: 'people-schema/group';

  @attr('number', { defaultValue: 0 })
  declare personType: EnumValue<typeof PersonType> | 0;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare customName: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @hasMany('people-schema/set', { async: true, inverse: 'groups' })
  declare templateSetIds: AsyncHasMany<Set>;

  @hasMany('people-schema/field', { async: true, inverse: 'templateGroupId' })
  declare fields: AsyncHasMany<Field>;

  @computed('fields.content.[]')
  get fieldsArray() {
    return resolved(this.fields);
  }
}
